export default "/assets/images/list-icon6.51e7fabf32c5cf97.svg";